import { render, staticRenderFns } from "./ReContactAllergyanamnesis.vue?vue&type=template&id=c812c0e0&lang=pug&"
import script from "./ReContactAllergyanamnesis.vue?vue&type=script&lang=js&"
export * from "./ReContactAllergyanamnesis.vue?vue&type=script&lang=js&"
import style0 from "./ReContactAllergyanamnesis.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports